import { Helmet } from "react-helmet";
import ContactUsLayout from "../sections/contactUs/contactUsLayout";

const ContactUsPage = () => {
    <Helmet>
        <title>Contact Us</title>
        <meta name="description" content="Got questions? Say hello to the Edliena team! Reach out to us for support, feedback, or a friendly chat about Learn with Cuddles. We’re happy to help parents, teachers, and little learners." />
        <meta name="keywords" content="Contact Edliena, contact Learn with Cuddles, kids learning support, parent help, teacher support, game feedback, get in touch, educational games help, customer support" />
        <link rel="canonical" href="https://cuddles.edliena.com/contact-us" />
    </Helmet>

    return (
        <>
            <ContactUsLayout />
        </>
    );
}

export default ContactUsPage;